import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import StatusPill from "@client/components/ui/StatusPill";
import Style from "@client/utils/Style";
import { Licence } from "@typings/Licence";
import { Tag } from "@typings/Tag";

import migrationImage from "./resources/migration.svg";
import replicaImage from "./resources/replica.svg";

const Wrapper = styled.div`
  display: flex;
  margin-left: -8px;
  margin-top: -8px;
  flex-flow: wrap;
  > div {
    margin-left: 8px;
    margin-top: 8px;
  }
`;
const TagPill = styled.div``;
const TagItems = styled.div`
  display: flex;
  margin-left: -8px;
  > div {
    margin-left: 8px;
  }
`;
const TagItem = styled.div`
  display: flex;
  align-items: center;
`;
const TransferItemIcon = styled.div<{ icon: string }>`
  width: 24px;
  height: 24px;
  background: url("${props => props.icon}") center no-repeat;
  background-size: cover;
`;
type Props = {
  licences: Licence[];
  tags: Tag[];
};
@observer
class TagGroup extends React.Component<Props> {
  render() {
    if (!this.props.licences.length || !this.props.tags.length) {
      return null;
    }

    const tags = this.props.licences.reduce(
      (tagsArr, currValue) => {
        const foundTagItem: any = tagsArr.find(
          t => t[0] === (currValue.tag || "No Tag"),
        );
        if (foundTagItem) {
          foundTagItem[1] += currValue.migrations;
          foundTagItem[2] += currValue.replicas;
        } else {
          tagsArr.push([
            currValue.tag || "No Tag",
            currValue.migrations,
            currValue.replicas,
          ]);
        }
        return tagsArr;
      },
      [] as Array<[string, number, number]>,
    );
    tags.sort((t1, t2) => t2[1] + t2[2] - (t1[1] + t1[2]));

    return (
      <Wrapper>
        {tags.map(tagToRender => {
          const tag = this.props.tags.find(
            storeTag => storeTag.name === tagToRender[0],
          );
          return (
            <TagPill key={tagToRender[0]}>
              {tag ? (
                <StatusPill
                  label={tag.name}
                  backgroundColor={tag.color}
                  fontColor="white"
                  borderColor={tag.color}
                  style={{ marginTop: "4px" }}
                />
              ) : (
                <StatusPill
                  label="No Tag"
                  backgroundColor="white"
                  fontColor={Style.palette.primary}
                  borderColor={Style.palette.primary}
                  style={{ marginTop: "4px" }}
                />
              )}
              <TagItems>
                <TagItem>
                  <TransferItemIcon
                    icon={migrationImage}
                    title={`${tagToRender[1]} ${tagToRender[0]} Migrations`}
                  />
                  {tagToRender[1]}
                </TagItem>
                <TagItem>
                  <TransferItemIcon
                    icon={replicaImage}
                    title={`${tagToRender[2]} ${tagToRender[0]} Replicas`}
                  />
                  {tagToRender[2]}
                </TagItem>
              </TagItems>
            </TagPill>
          );
        })}
      </Wrapper>
    );
  }
}

export default TagGroup;
